import React, { type ReactNode } from "react"
import { Container, useMediaQuery } from "@material-ui/core"
import clsx from "clsx"
import Button from "@material-ui/core/Button"
import * as styles from "./twoBlocks.module.scss"
import { variantConfig } from "./variants"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../../helpers/getTextFromNode"

type TwoBlocksProps = {
  orderNum: string
  variant: "download"
  headTitle?: string | JSX.Element
}

const defaultTitle = (
  <>
    Дебетовая карта и&nbsp;покупки в&nbsp;рассрочку*: <br /> всё — в&nbsp;одной карте!
  </>
)

const handleClick = (buttonText: string, titleBlock: ReactNode) => {
  DLClickEventExtended({
    name: buttonText,
    eventAction: getTextFromNode(titleBlock),
    eventCategory: "click_block",
    placement: "debit_card_installments",
  })

  scrollToPersonalForm()
}

export const TwoBlocks = ({ variant, orderNum, headTitle = defaultTitle }: TwoBlocksProps) => {
  const data = variantConfig[variant]
  const isDesktop = useMediaQuery("(min-width:1279.95px)")

  return (
    <div data-exclude={orderNum}>
      <Container className={clsx(styles.container, variant && styles[variant])}>
        {headTitle && <h2 className={styles.headTitle}>{headTitle}</h2>}

        <div className={styles.cardList}>
          {data.map(({ title, description, Icon, alt, buttonText, secondary }, index) => (
            <div key={index} className={clsx(styles.card, styles[`card${index + 1}`])}>
              <div className={styles.textBlock}>
                <div>
                  {title && <h3 className={styles.title}>{title}</h3>}
                  {description && <p className={styles.description}>{description}</p>}
                </div>
                {buttonText && isDesktop && (
                  <Button
                    disableRipple
                    onClick={() => handleClick(buttonText, title)}
                    className={clsx(styles.btn, secondary && styles.secondary)}
                  >
                    {buttonText}
                  </Button>
                )}
              </div>

              <Icon className={styles.img} alt={alt} />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
